<template>
<div class="box">
  <router-link :to="{
    name: 'route-manager',
    params: {
      app: audit.app_id,
      environment: audit.environment_id,
      route: finding.findable.id
    }
  }">
    <route-uri 
      :uri="finding.findable.uri"
    />
  </router-link>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {

  props: {
    finding: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapGetters('audit', [
      'audit'
    ])
  }
  
}
</script>